<template>
  <section v-bind="$attrs" class="company-culture">
    <div class="company-title-wrap">
      <h4 class="company-title">{{ $t('menuCompany.woowaCulture') }}</h4>
    </div>

    <div ref="vision" class="company-box vision" :data-id="$t('vision.name')">
      <h5 :id="$t('vision.name').replace(/\s/g, '')">{{ $t('vision.name') }}</h5>
      <div class="company-box-image">
        <p>
          <picture class="tab-image mobile-active" :class="{active: vision === 3}">
            <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_vision_3@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_vision_3@3x.jpg 3x">
            <img src="~@/static/image/company/pc/image_vision_3.jpg" :alt="$t('vision.name')">
          </picture>
          <picture class="tab-image" :class="{active: vision === 2}">
            <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_vision_2@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_vision_2@3x.jpg 3x">
            <img src="~@/static/image/company/pc/image_vision_2.jpg" :alt="$t('vision.name')">
          </picture>
          <picture class="tab-image" :class="{active: vision === 1}">
            <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_vision_1@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_vision_1@3x.jpg 3x">
            <img src="~@/static/image/company/pc/image_vision_1.jpg" :alt="$t('vision.name')">
          </picture>
        </p>
      </div>
      <html-view :value="$t('vision.title')" class="company-box-title" />
      <div class="company-box-content">
        <div class="vision-tab">
          <div class="nav-tabs">
            <button type="button" :class="{active: vision === 3}" @click="onChangeVision(3)">{{ $t('vision.tab3.menu') }}</button>
            <button type="button" :class="{active: vision === 2}" @click="onChangeVision(2)">{{ $t('vision.tab2.menu') }}</button>
            <button type="button" :class="{active: vision === 1}" @click="onChangeVision(1)">{{ $t('vision.tab1.menu') }}</button>
          </div>
          <div class="nav-item-wrap">
            <div class="nav-item" :class="{active: vision === 3}">
              <div class="vision-version">{{ $t('vision.tab3.menu') }}</div>
              <div class="vision-content">
                <html-view :value="$t('vision.tab3.title')" class="vision-content-title" />
                <html-view :value="$t('vision.tab3.content')" />
                <time>{{ $t('vision.tab3.date') }}</time>
              </div>
            </div>
            <div class="nav-item" :class="{active: vision === 2}">
              <div class="vision-image">
                <p>
                  <picture>
                    <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_vision_2@3x.jpg 3x">
                    <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_vision_2@3x.jpg 3x">
                    <img src="~@/static/image/company/pc/image_vision_2.jpg" :alt="$t('vision.name')">
                  </picture>
                </p>
              </div>
              <div class="vision-version">{{ $t('vision.tab2.menu') }}</div>
              <div class="vision-content">
                <html-view :value="$t('vision.tab2.title')" class="vision-content-title" />
                <html-view :value="$t('vision.tab2.content')" />
                <time>{{ $t('vision.tab2.date') }}</time>
              </div>
            </div>
            <div class="nav-item" :class="{active: vision === 1}">
              <div class="vision-image">
                <p>
                  <picture>
                    <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_vision_1@3x.jpg 3x">
                    <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_vision_1@3x.jpg 3x">
                    <img src="~@/static/image/company/pc/image_vision_1.jpg" :alt="$t('vision.name')">
                  </picture>
                </p>
              </div>
              <div class="vision-version">{{ $t('vision.tab1.menu') }}</div>
              <div class="vision-content">
                <html-view :value="$t('vision.tab1.title')" class="vision-content-title" />
                <html-view :value="$t('vision.tab1.content')" />
                <time>{{ $t('vision.tab1.date') }}</time>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template>
      <div ref="principle" class="company-box principle" :data-id="$t('principles.name')">
        <h5 :id="$t('principles.name').replace(/\s/g, '')">{{ $t('principles.name') }}</h5>
        <div class="company-box-image">
          <p>
            <picture>
              <source srcset="~@/static/image/company/principle@2x.jpg 2x">
              <img src="~@/static/image/company/principle.jpg" :alt="$t('principles.name')">
            </picture>
          </p>
        </div>
        <html-view :value="$t('principles.title')" class="company-box-title" />
        <div class="company-box-content">
          <div class="preface">
            <html-view :value="$t('principles.paragraph1')" class="paragraph" />
            <html-view :value="$t('principles.paragraph2')" class="paragraph bold" />
            <html-view :value="$t('principles.paragraph3')" class="paragraph bold" />
            <html-view :value="$t('principles.paragraph4')" class="paragraph" />
            <html-view :value="$t('principles.paragraph5')" class="paragraph" />
          </div>

          <div class="company-box-sub">
            <html-view :value="$t('principles.group1.title')" class="company-box-subtitle" />
            <html-view :value="$t('principles.group1.desc')" class="principle-desc" />
            <ul class="principle-list">
              <li>
                <div class="principle-list-title">{{ $t('principles.group1.list.item1.title') }}</div>
                <div>{{ $t('principles.group1.list.item1.content') }}</div>
              </li>
              <li>
                <div class="principle-list-title">{{ $t('principles.group1.list.item2.title') }}</div>
                <div>{{ $t('principles.group1.list.item2.content') }}</div>
              </li>
              <li>
                <div class="principle-list-title">{{ $t('principles.group1.list.item3.title') }}</div>
                <div>{{ $t('principles.group1.list.item3.content') }}</div>
              </li>
            </ul>
          </div>
          <div class="company-box-sub">
            <html-view :value="$t('principles.group2.title')" class="company-box-subtitle" />
            <html-view :value="$t('principles.group2.desc')" class="principle-desc" />
            <ul class="principle-list">
              <li>
                <div class="principle-list-title">{{ $t('principles.group2.list.item1.title') }}</div>
                <div>{{ $t('principles.group2.list.item1.content') }}</div>
              </li>
              <li>
                <div class="principle-list-title">{{ $t('principles.group2.list.item2.title') }}</div>
                <div>{{ $t('principles.group2.list.item2.content') }}</div>
              </li>
              <li>
                <div class="principle-list-title">{{ $t('principles.group2.list.item3.title') }}</div>
                <div>{{ $t('principles.group2.list.item3.content') }}</div>
              </li>
            </ul>
          </div>
          <div class="company-box-sub">
            <html-view :value="$t('principles.group3.title')" class="company-box-subtitle" />
            <html-view :value="$t('principles.group3.desc')" class="principle-desc" />
            <ul class="principle-list">
              <li>
                <div class="principle-list-title">{{ $t('principles.group3.list.item1.title') }}</div>
                <div>{{ $t('principles.group3.list.item1.content') }}</div>
              </li>
              <li>
                <div class="principle-list-title">{{ $t('principles.group3.list.item2.title') }}</div>
                <div>{{ $t('principles.group3.list.item2.content') }}</div>
              </li>
              <li>
                <div class="principle-list-title">{{ $t('principles.group3.list.item3.title') }}</div>
                <div>{{ $t('principles.group3.list.item3.content') }}</div>
              </li>
            </ul>
          </div>
          <div class="company-box-sub">
            <html-view :value="$t('principles.group4.title')" class="company-box-subtitle" />
            <html-view :value="$t('principles.group4.desc')" class="principle-desc" />
            <ul class="principle-list">
              <li>
                <div class="principle-list-title">{{ $t('principles.group4.list.item1.title') }}</div>
                <div>{{ $t('principles.group4.list.item1.content') }}</div>
              </li>
              <li>
                <div class="principle-list-title">{{ $t('principles.group4.list.item2.title') }}</div>
                <div>{{ $t('principles.group4.list.item2.content') }}</div>
              </li>
              <li>
                <div class="principle-list-title">{{ $t('principles.group4.list.item3.title') }}</div>
                <div>{{ $t('principles.group4.list.item3.content') }}</div>
              </li>
            </ul>
          </div>
          <div class="company-box-sub">
            <html-view :value="$t('principles.group5.title')" class="company-box-subtitle" />
            <html-view :value="$t('principles.group5.desc')" class="principle-desc" />
            <ul class="principle-list">
              <li>
                <div class="principle-list-title">{{ $t('principles.group5.list.item1.title') }}</div>
                <div>{{ $t('principles.group5.list.item1.content') }}</div>
              </li>
              <li>
                <div class="principle-list-title">{{ $t('principles.group5.list.item2.title') }}</div>
                <div>{{ $t('principles.group5.list.item2.content') }}</div>
              </li>
              <li>
                <div class="principle-list-title">{{ $t('principles.group5.list.item3.title') }}</div>
                <div>{{ $t('principles.group5.list.item3.content') }}</div>
              </li>
            </ul>
          </div>
          <div class="company-box-sub">
            <html-view :value="$t('principles.group6.title')" class="company-box-subtitle" />
            <html-view :value="$t('principles.group6.desc')" class="principle-desc" />
            <ul class="principle-list">
              <li>
                <div class="principle-list-title">{{ $t('principles.group6.list.item1.title') }}</div>
                <div>{{ $t('principles.group6.list.item1.content') }}</div>
              </li>
              <li>
                <div class="principle-list-title">{{ $t('principles.group6.list.item2.title') }}</div>
                <div>{{ $t('principles.group6.list.item2.content') }}</div>
              </li>
              <li>
                <div class="principle-list-title">{{ $t('principles.group6.list.item3.title') }}</div>
                <div>{{ $t('principles.group6.list.item3.content') }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
    <!--<template v-else>
      <div ref="value" class="company-box value" :data-id="$t('value.name')">
        <h5 :id="$t('value.name').replace(/\s/g, '')">{{ $t('value.name') }}</h5>
        <div class="company-box-image">
          <p>
            <picture>
              <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_value@3x.jpg 3x">
              <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_value@3x.jpg 3x">
              <img src="~@/static/image/company/pc/image_value.jpg" :alt="$t('value.name')">
            </picture>
          </p>
        </div>
        <html-view :value="$t('value.title')" class="company-box-title" />
        <div class="company-box-content">
          <ul class="value-list">
            <li>
              <div class="value-list-title">{{ $t('value.list.item1.title') }}</div>
              <div>{{ $t('value.list.item1.content') }}</div>
            </li>
            <li>
              <div class="value-list-title">{{ $t('value.list.item2.title') }}</div>
              <div>{{ $t('value.list.item2.content') }}</div>
            </li>
            <li>
              <div class="value-list-title">{{ $t('value.list.item3.title') }}</div>
              <div>{{ $t('value.list.item3.content') }}</div>
            </li>
            <li>
              <div class="value-list-title">{{ $t('value.list.item4.title') }}</div>
              <div>{{ $t('value.list.item4.content') }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div ref="people" class="company-box people" :data-id="$t('people.name')">
        <h5 :id="$t('people.name')">{{ $t('people.name') }}</h5>
        <div class="company-box-image">
          <p>
            <picture>
              <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_people@3x.jpg 3x">
              <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_people@3x.jpg 3x">
              <img src="~@/static/image/company/pc/image_people.jpg" :alt="$t('people.name')">
            </picture>
          </p>
        </div>
        <html-view :value="$t('people.title')" class="company-box-title" />
        <div class="company-box-content">
          <ul class="people-list">
            <li>
              <div class="people-list-title">{{ $t('people.list.item1.title') }}</div>
              <div>{{ $t('people.list.item1.content') }}</div>
            </li>
            <li>
              <div class="people-list-title">{{ $t('people.list.item2.title') }}</div>
              <div>{{ $t('people.list.item2.content') }}</div>
            </li>
            <li>
              <div class="people-list-title">{{ $t('people.list.item3.title') }}</div>
              <div>{{ $t('people.list.item3.content') }}</div>
            </li>
            <li>
              <div class="people-list-title">{{ $t('people.list.item4.title') }}</div>
              <div>{{ $t('people.list.item4.content') }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div ref="better" class="company-box better" :data-id="$t('better.name')">
        <h5 :id="$t('better.name').replace(/\s/g, '')">{{ $t('better.name') }}</h5>
        <html-view :value="$t('better.title')" class="company-box-title" />
        <div class="company-box-content">
          <html-view :value="$t('better.paragraph')" class="paragraph" />
          <div class="better-image">
            <picture>
              <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_better@3x.jpg 3x">
              <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_better@3x.jpg 3x">
              <img src="~@/static/image/company/pc/image_better.jpg" :alt="$t('better.name')">
            </picture>
          </div>
          <div class="better-download">
            <div class="link-select">
              <button
                class="link-select-button"
                type="button"
                :class="{
                  'link-select-active': isBetterShow
                }"
                @click="onBetterToggle"
              >
                <span>{{ $t('better.download.title') }}</span>
                <span class="down"><icon-chevron-down /></span>
              </button>
              <transition name="link-select">
                <ul v-if="isBetterShow" class="link-select-list">
                  <li>
                    <a :href="require('@/static/download/poster_RGB.jpeg')" download target="_blank">{{ $t('better.download.imageKr') }}</a>
                  </li>
                  <li>
                    <a :href="require('@/static/download/poster_CMYK.pdf')" download target="_blank">{{ $t('better.download.pdfKr') }}</a>
                  </li>
                  <li>
                    <a :href="require('@/static/download/poster_RGB_eng.jpg')" download target="_blank">{{ $t('better.download.imageEn') }}</a>
                  </li>
                  <li>
                    <a :href="require('@/static/download/poster_CMYK_eng.pdf')" download target="_blank">{{ $t('better.download.pdfEn') }}</a>
                  </li>
                </ul>
              </transition>
            </div>
          </div>
          <ol class="better-list">
            <li>
              <html-view :value="$t('better.list.item1.title')" class="better-list-title" />
              <div>{{ $t('better.list.item1.content') }}</div>
            </li>
            <li>
              <html-view :value="$t('better.list.item2.title')" class="better-list-title" />
              <div>{{ $t('better.list.item2.content') }}</div>
            </li>
            <li>
              <html-view :value="$t('better.list.item3.title')" class="better-list-title" />
              <div>{{ $t('better.list.item3.content') }}</div>
            </li>
            <li>
              <html-view :value="$t('better.list.item4.title')" class="better-list-title" />
              <div>{{ $t('better.list.item4.content') }}</div>
            </li>
            <li>
              <html-view :value="$t('better.list.item5.title')" class="better-list-title" />
              <div>{{ $t('better.list.item5.content') }}</div>
            </li>
            <li>
              <html-view :value="$t('better.list.item6.title')" class="better-list-title" />
              <div>{{ $t('better.list.item6.content') }}</div>
            </li>
            <li>
              <html-view :value="$t('better.list.item7.title')" class="better-list-title" />
              <div>{{ $t('better.list.item7.content') }}</div>
            </li>
            <li>
              <html-view :value="$t('better.list.item8.title')" class="better-list-title" />
              <div>{{ $t('better.list.item8.content') }}</div>
            </li>
            <li>
              <html-view :value="$t('better.list.item9.title')" class="better-list-title" />
              <div>{{ $t('better.list.item9.content') }}</div>
            </li>
            <li>
              <html-view :value="$t('better.list.item10.title')" class="better-list-title" />
              <div>{{ $t('better.list.item10.content') }}</div>
            </li>
            <li>
              <html-view :value="$t('better.list.item11.title')" class="better-list-title" />
              <div>{{ $t('better.list.item11.content') }}</div>
            </li>
          </ol>
        </div>
      </div>
    </template>-->
  </section>
</template>
<script>
import gtag from '@/mixins/gtag'
import isKorean from '@/mixins/isKorean'

export default {
  components: {
    // iconChevronDown: () => import('@/static/svg/chevron-down.svg'),
  },
  mixins: [gtag, isKorean],
  data () {
    return {
      isBetterShow: false,
      vision: 3,
      sections: [
        'vision',
        'value',
        'people',
        'better'
      ]
    }
  },
  mounted () {
    this.$emit('loaded:component')
    // this.initObserver(this.$el.querySelectorAll('section'))
    this.$nextTick(this.init)
  },
  methods: {
    init () {
      this.sections.forEach(section => {
        if (this.$refs[section]) {
          this.initGtag({
            element: this.$refs[section],
            isView: true,
            ga: {
              name: '회사소개_우아한 문화',
              category: '회사소개_우아한 문화',
              label: this.$t(`${section}.name`),
              page: '회사소개'
            }
          })
        }
      })
    },
    onBetterToggle () {
      this.isBetterShow = !this.isBetterShow

      const docEvents = (e) => {
        if (!e.target.closest('.link-select')) {
          this.isBetterShow = false
          document.documentElement.removeEventListener('click', docEvents)
        }
      }

      document.documentElement.addEventListener('click', docEvents)
    },
    onChangeVision (index) {
      this.vision = index
    }
  }
}
</script>
